import { render, staticRenderFns } from "./LocalTopTips.vue?vue&type=template&id=b630e266&scoped=true"
import script from "./LocalTopTips.ts?vue&type=script&lang=ts&external"
export * from "./LocalTopTips.ts?vue&type=script&lang=ts&external"
import style0 from "./LocalTopTips.vue?vue&type=style&index=0&id=b630e266&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b630e266",
  null
  
)

export default component.exports